import React, { Component } from 'react';

class PatientPartial extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 


        const {patient} = this.props;

        return (  

            <div class="panel panel-default">
                <div class="panel-heading">
                    <a data-toggle = "collapse" href = "#patient">
                    <b>نام :</b>   {patient && patient.FirstName}  &nbsp;&nbsp; 
                       
                    <b>نام خانوادگی :</b>   {patient && patient.LastName}   &nbsp;&nbsp;

                    <b>کد ملی :</b>   {patient && patient.NationalCode} 
                    </a>                   
                </div>
                <div id = "patient" className = "panel-collapse collapse">
                    <div class="panel-body">

                        <div className="form-horizontal">

                            <div className="col-md-3">

                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="email">نام</label>
                                    <div class="col-sm-9">
                                        {patient && patient.FirstName}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-6" for="email">شماره شناسنامه</label>
                                    <div class="col-sm-5">
                                        {patient && patient.IdentityCode}
                                    </div>
                                </div>
                                
                                

                            </div>
                            <div className="col-md-4">
                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="email">نام خانوادگی</label>
                                    <div class="col-sm-8">
                                        {patient && patient.LastName}   
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="email">نام پدر</label>
                                    <div class="col-sm-9">
                                        {patient && patient.FatherName}   
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="email">کد ملی</label>
                                    <div class="col-sm-9">
                                    {patient && patient.NationalCode} 
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="email">محل صدور</label>
                                    <div class="col-sm-8">
                                    {patient && patient.IdentityCityName} 
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 text-center">
                                <div className="rcorners1">
                                    <img src={patient && patient.PatientImg}  width={90} height={90}></img>
                                </div>
                            </div>
                        
                        
                        
                        </div>


                    </div>
                </div>
            </div>
        );
    }
}
 
export default PatientPartial;